function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgMap = function SvgMap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8EEFC"
    },
    d: "M511.342,501.574l-73.78-178.607c-1.16-2.808-3.882-4.637-6.901-4.637H81.339 c-3.019,0-5.742,1.83-6.901,4.637L0.657,501.574c-0.961,2.324-0.705,4.979,0.683,7.073C2.727,510.742,5.06,512,7.559,512h496.882 c2.498,0,4.832-1.259,6.219-3.353C512.047,506.554,512.302,503.899,511.342,501.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EE5F2"
    },
    d: "M480.641,512h23.8c2.498,0,4.832-1.259,6.219-3.353c1.387-2.093,1.643-4.748,0.683-7.073 l-73.78-178.607c-1.16-2.808-3.882-4.637-6.901-4.637h-30.023L480.641,512z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CE166"
    },
    d: "M123.166,385.691l25.459-67.528H80.866c-3.019,0-5.742,1.83-6.901,4.637l-25.98,62.891H123.166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CE166"
    },
    d: "M430.188,318.163H194.912l68.623,59.839h196.358l-22.803-55.201 C435.929,319.994,433.207,318.163,430.188,318.163z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4CE166"
    },
    points: "461.655,382.269 463.069,385.691 463.069,385.691  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDB56"
    },
    points: "482.581,432.928 459.893,378.002 263.534,378.002 194.912,318.163 148.878,318.163  143.02,318.163 118.18,377.987 51.169,377.987 36.117,414.423 28.473,432.928 95.555,432.928 62.962,511.833 123.941,511.833  176.291,383.658 327.257,511.833 416.385,511.833 326.161,432.928 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4A4A"
    },
    d: "M255.527,0C166.495,0,94.063,72.977,94.063,162.678c0,30.924,8.352,63.733,24.827,97.515 c13.036,26.734,31.175,54.161,53.91,81.52c38.572,46.415,76.553,76.214,78.152,77.461c1.348,1.051,2.961,1.574,4.575,1.574 s3.228-0.525,4.575-1.574c1.598-1.247,39.579-31.046,78.152-77.461c22.736-27.359,40.875-54.786,53.91-81.52 c16.475-33.783,24.827-66.591,24.827-97.515C416.991,72.977,344.559,0,255.527,0z M255.527,100.798 c33.92,0,61.418,27.705,61.418,61.88s-27.498,61.88-61.418,61.88s-61.418-27.705-61.418-61.88 C194.109,128.503,221.607,100.798,255.527,100.798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7343F"
    },
    d: "M255.527,0c-5.313,0-10.566,0.268-15.749,0.775c81.668,8.002,145.715,77.555,145.715,161.903 c0,30.924-8.352,63.733-24.827,97.515c-13.036,26.734-31.175,54.161-53.91,81.52c-26.454,31.833-52.626,55.846-66.978,68.197 c6.575,5.658,10.672,8.872,11.173,9.263c1.348,1.051,2.961,1.574,4.575,1.574s3.228-0.525,4.575-1.574 c1.598-1.247,39.579-31.046,78.152-77.461c22.736-27.359,40.875-54.786,53.91-81.52c16.475-33.783,24.827-66.591,24.827-97.515 C416.991,72.977,344.559,0,255.527,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4CE166"
    },
    points: "123.941,511.833 327.257,511.833 176.291,383.658 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFBB24"
    },
    points: "424.884,378.002 447.573,432.928 482.581,432.928 459.893,378.002 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C868"
    },
    d: "M424.884,378.002h35.009l-22.803-55.201c-1.16-2.808-3.882-4.637-6.901-4.637h-30.023 L424.884,378.002z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map.7ba5c4ca.svg";
export { ForwardRef as ReactComponent };